import {Integration} from "../../../../../../../api/generated";
import {SelectOption} from "../../../../../../elements/select/SelectDropdown";

export const allIntegrationOptions: SelectOption<Integration>[] = [
    {
        label: "Superchat",
        value: Integration.Superchat
    }
]

export const getIntegrationName = (value: Integration) => {
    const option = allIntegrationOptions.filter(o => o.value === value)

    if (option && option.length === 1) {
        return option[0].label
    }

    throw new Error(`Unable to handle integration: ${value} correctly`)
}
